module.exports = __webpack_public_path__ + "static/renaissance-aecc39505e4a3f54fef0d38d12ab5e5b.png";